module.exports = __webpack_public_path__ + "static/media/2017_3.60e3ae08.png";